import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as types from './alert-constants';
import * as alertActions from './alert-actions';

export function* snoozeAlert(action) {
  try {
    const { id, seconds, laneId, blockId } = action.payload;
    const results = yield call(callApi, {
      endpoint: `alert/${id}/snooze?seconds=${seconds}`,
      options: {
        method: 'POST',
        errorMessage: 'Could not snooze alert',
        retryAction: action,
      },
    });
    yield put(alertActions.snoozeSuccess({ ...results, laneId, blockId }));
  } catch (err) {
    yield put(alertActions.snoozeFailure(err));
  }
}

function* watchSnoozeAlert() {
  yield takeLatest(types.ALERT_SNOOZE_REQUEST, snoozeAlert);
}

export function* discardAlert(action) {
  try {
    const { id, laneId, blockId } = action.payload;
    const results = yield call(callApi, {
      endpoint: `alert/${id}/discard`,
      options: {
        method: 'POST',
        errorMessage: 'Could not discard alert',
        retryAction: action,
      },
    });
    yield put(alertActions.discardSuccess({ ...results, laneId, blockId }));
  } catch (err) {
    yield put(alertActions.discardFailure(err));
  }
}

function* watchDiscardAlert() {
  yield takeLatest(types.ALERT_DISCARD_REQUEST, discardAlert);
}

export default [fork(watchSnoozeAlert), fork(watchDiscardAlert)];
